<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col class="">
          <h3 class="text-center">
            {{ details.clearance_organization }} have Uploaded {{ alltopicsarray.length }} Topics in Total
          </h3>

           <div v-if="topicstabledata.length > 0">
              <h2 class="text-center">{{ topicstabledata[0].name }}</h2>
              <h4 class="text-center" v-if="topicstabledata.length > 0">This Table has {{ topicstabledata[0].data.length }} rows</h4>
              <tabler2 v-if="topicstabledata.length > 0"  class="esq m-0 p-0" :datas="topicstabledata[0].data" :fields="topicstabledata[0].fields"></tabler2>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Tabler2 from '@/components/admin/Tabler2';
import { mapState, mapActions } from "vuex";
import store from "@/store";

export default {
  components: {
    //QuestionsList,
    Tabler2
  },

  data() {
    return {
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 15,
        endnum: 15,
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchAllTopics");
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setnextid(to.params.trackid).then(() => {
      next();
    });
  },
  created() {
    //this.fetchQuestions(this.name)

    this.fetchTopicStocks()
  },
  methods: {
    ...mapActions("admin", ["fetchAllTopics", "setnextid", "fetchTopicStocks"]),
    showMore() {
      let newend = this.endnum + this.intervalnum;

      if (newend < this.endss) {
        this.endnum = newend;
      } else {
        this.endnum = this.limitnum;
      }
    },
  },
  computed: {
    ...mapState({
      details : state => state.loginmaster.details,
      name: (state) => state.loginmaster.details.fullname,
      trackid : state => state.loginmaster.details.trackid,
      alltopicsarray: (state) => state.admin.alltopicsarray,
      topicstabledata : state => state.admin.topicstabledata
    }),
    usedatas() {
      return this.alltopicsarray.slice(0, this.endnum);
    },
    endss() {
      let end = this.alltopicsarray.length;
      return end;
    },
  },
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
</style>
